import { Example } from '@/rule/domain/Example.ts';

export class Examples {
  readonly #list: Example[];

  private constructor(list: Example[]) {
    this.#list = list;
  }

  static of(...list: Example[]): Examples {
    return new Examples(list);
  }

  get list(): Example[] {
    return [...this.#list];
  }

  isEmpty(): boolean {
    return this.#list.length === 0;
  }
}
